import locale from "./locale";

export default {
    methods: {
        lang(id : string) : string {
            return locale.get(id);
        },
    }
}